const ArrowUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={22}
      fill="none"
      viewBox="0 0 24 22"
    >
      <path d="M13.002 6.71191L12.0488 6.75781C8.02686 6.94957 5.1624 8.47305 3.35254 11.2061C1.85267 13.4707 1.02956 16.679 1.00293 20.835C2.29501 19.1412 3.59402 17.7183 5.4082 16.7451L5.41016 16.7441C7.15519 15.8111 9.28479 15.3585 11.9697 15.2744L13.002 15.2422V20.8799L22.9932 10.998L13.002 1.11621V6.71191Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default ArrowUp;
